import { Upload as AntUpload, type UploadProps as AntUploadProps } from "antd";

export type UploadProps = AntUploadProps;

function UploadComponent(props: UploadProps) {
  return <AntUpload {...props} />;
}

export const Upload = Object.assign(UploadComponent, {
  LIST_IGNORE: AntUpload.LIST_IGNORE,
});
